import _extends from 'babel-runtime/helpers/extends';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import * as style from './Input.style';
import { getAllowedAttributes } from '../props-filters';

var InputIcon = function (_PureComponent) {
  _inherits(InputIcon, _PureComponent);

  function InputIcon() {
    _classCallCheck(this, InputIcon);

    return _possibleConstructorReturn(this, (InputIcon.__proto__ || _Object$getPrototypeOf(InputIcon)).apply(this, arguments));
  }

  _createClass(InputIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          _props$shown = _props.shown,
          shown = _props$shown === undefined ? true : _props$shown;

      var allowedProps = getAllowedAttributes(this.props);
      return React.createElement(
        'div',
        _extends({}, allowedProps, { className: cx(className, style.icon(shown)) }),
        children
      );
    }
  }]);

  return InputIcon;
}(PureComponent);

InputIcon.propTypes = {
  children: PropTypes.node.isRequired,
  shown: PropTypes.bool,
  className: PropTypes.string
};
export default InputIcon;